/* eslint-disable */
/* tslint:disable */

import { BackTop, ConfigProvider, Layout, message } from 'antd';
import { observer } from 'mobx-react';
import MainRouter from './features/routers/main-router';
import zhCN from 'antd/es/locale/zh_CN';
// order important so we can override antd
import 'antd/dist/antd.css';
import './App.scss';
import Footer from './components/footer/footer';
import Header from './components/header/header';
import Banner from './features/activity/banner';
import HomeBanner from './features/activity/home-banner';

const { Content } = Layout;
/* 不需要header和footer的页面 */
const exclusionNavArray = ['/data', '/login'];
const exclusionHeaderArray = ['/login'];
const bgMap = {
  '/data': 'bg__data',
};

let isMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);

function App(props: any) {
  return (
    <ConfigProvider locale={zhCN}>
      <div
        className={`${
          exclusionNavArray.indexOf(window.location.pathname) < 0
            ? 'has__header'
            : (bgMap as any)[window.location.pathname]
        }`}
      >
        {!isMobile && (
          <>
            <Layout className="">
              {/*     {exclusionNavArray.indexOf(window.location.pathname) < 0 && (  )}*/}
              {exclusionHeaderArray.indexOf(window.location.pathname) < 0 && (
                <>
                  <Header />
                  {window.location.pathname !== '/' && <Banner />}
                </>
              )}
              {window.location.pathname === '/' && <HomeBanner />}

              <Content className={`${window.location.pathname === '/' ? 'no-padding' : ''} site-layout App`}>
                <MainRouter />
                <BackTop />
              </Content>
            </Layout>
            {exclusionNavArray.indexOf(window.location.pathname) < 0 && (
              <Footer />
            )}
          </>
        )}
        {isMobile && (
          <>
            {message.info({
              content: '电脑端观看及报名体验更佳',
              duration: 10,
              style: {
                marginTop: '28vh',
                fontSize: '28px',
              },
            })}
            <Layout className="">
              {/*     {exclusionNavArray.indexOf(window.location.pathname) < 0 && (  )}*/}
              {exclusionHeaderArray.indexOf(window.location.pathname) < 0 && (
                <>
                  <Header />
                  {window.location.pathname !== '/' && <Banner />}
                </>
              )}
              {window.location.pathname === '/' && <HomeBanner />}

              <Content className={`${window.location.pathname === '/' ? 'no-padding' : ''} site-layout App`}>
                <MainRouter />
                <BackTop />
              </Content>
            </Layout>
            {exclusionNavArray.indexOf(window.location.pathname) < 0 && (
              <Footer />
            )}
          </>
          // <Result
          //   className="top-level-mask"
          //   icon={<></>}
          //   title="用电脑打开体验更佳！"
          // />
        )}
      </div>
    </ConfigProvider>
  );
}

export default observer(App);
